
<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Settings</v-card-title>
          <v-card-text>
            <v-switch v-model="themeIsDark" label="Dark Theme"></v-switch>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Colors</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <div class="mb-3">Primary color</div>
                <v-color-picker
                  mode.sync="hexa"
                  v-model="themePrimaryColor"
                  class="mb-5"
                ></v-color-picker>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title> Font </v-card-title>
          <v-card-text>
            <v-select
              :items="fonts"
              label="Choose your font"
              v-model="themeFont"
            ></v-select>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Assets</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <strong>Logo Image</strong>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Logo image URL"
                  v-model="themeLogoImageUrl"
                  @click="onUpload('logo', themeLogoImageUrl)"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-card>
                  <v-img
                    :src="themeLogoImageUrl"
                    alt="themeLogoImageUrl"
                    class="image"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <strong>Header Image</strong>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Header image URL"
                  v-model="themeHeaderImageUrl"
                  @click="onUpload('header', themeHeaderImageUrl)"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-card>
                  <v-img
                    :src="themeHeaderImageUrl"
                    alt="themeHeaderImageUrl"
                    class="image"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <strong>Background Image</strong>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Background image URL"
                  v-model="themeBackgroundImageUrl"
                  @click="onUpload('background', themeBackgroundImageUrl)"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-card>
                  <v-img
                    :src="themeBackgroundImageUrl"
                    alt="themeBackgroundImageUrl"
                    class="image"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <strong>Newsletter/Prize Image</strong>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Newsletter/Prize image URL"
                  v-model="themeNewsletterImageUrl"
                  @click="onUpload('newsletter', themeNewsletterImageUrl)"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-card>
                  <v-img
                    :src="themeNewsletterImageUrl"
                    alt="themeNewsletterImageUrl"
                    class="image"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import cms from '@/cms'
import { Component, Vue } from 'vue-property-decorator'
import { Font } from '../../types'

@Component({
  components: {
  }
})
export default class BuilderTheme extends Vue {
  fonts: Font[] = Object.values(Font)

  get themeFont () {
    return this.$store.getters.themeFont
  }

  set themeFont (data: string) {
    this.$store.commit('SET_THEME_FONT', data)
  }

  get themeIsDark () {
    return this.$store.getters.themeIsDark
  }

  set themeIsDark (data: boolean) {
    this.$store.commit('SET_THEME_IS_DARK', data)
  }

  get themePrimaryColor () {
    return this.$store.getters.themePrimaryColor
  }

  set themePrimaryColor (data: string) {
    this.$store.commit('SET_THEME_PRIMARY_COLOR', data)
  }

  get themeLogoImageUrl () {
    return this.$store.getters.themeLogoImageUrl
  }

  set themeLogoImageUrl (data: string) {
    this.$store.commit('SET_THEME_LOGO_IMAGE_URL', data)
  }

  get themeHeaderImageUrl () {
    return this.$store.getters.themeHeaderImageUrl
  }

  set themeHeaderImageUrl (data: string) {
    this.$store.commit('SET_THEME_HEADER_IMAGE_URL', data)
  }

  get themeBackgroundImageUrl () {
    return this.$store.getters.themeBackgroundImageUrl
  }

  set themeBackgroundImageUrl (data: string) {
    this.$store.commit('SET_THEME_BACKGROUND_IMAGE_URL', data)
  }

  get themeNewsletterImageUrl () {
    return this.$store.getters.themeNewsletterImageUrl
  }

  set themeNewsletterImageUrl (data: string) {
    this.$store.commit('SET_THEME_NEWSLETTER_IMAGE_URL', data)
  }

  async onUpload (currentFileId: string, currentUrl: string|null) {
    const fileResult = await cms.selectMediaFile({ fieldId: currentFileId, currentFileUrl: currentUrl })
    console.log('fileResult', fileResult)
    if (fileResult) {
      switch (currentFileId) {
        case 'logo': {
          this.themeLogoImageUrl = fileResult.url
          break
        }
        case 'header': {
          this.themeHeaderImageUrl = fileResult.url
          break
        }
        case 'background': {
          this.themeBackgroundImageUrl = fileResult.url
          break
        }
        case 'newsletter': {
          this.themeNewsletterImageUrl = fileResult.url
          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>
